// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-dashboard {
  background: #363955;
  border-radius: 15px;
  margin: 0 auto;
  /* padding: 20px; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 20px;
  margin-bottom: 45px;
  padding-bottom: 20px;

  .customer-head-box {
    background: #42466b;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    width: 100%;
    padding: 10px 20px;

    .customer-header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .customer-heading {
        color: white;
        font-size: 16px;
        font-weight: 700;
      }

      .customer-dtTime {
        font-size: 12px;
        color: #acacac;
      }
    }
  }

  .customer-tabs {
    display: flex;
    /* justify-content: center; */
    width: 100%;
    margin: 10px 0 0 0;

    .customer-tab-button {
      /* flex: 1; */
      padding: 2px;
      cursor: pointer;
      background: none;
      border: none;
      border-bottom: 2px solid transparent;
      font-size: 12px;
      color: #99adc4;
      width: 13%;
      margin-left: 40px;    

      &.active {
        border-bottom: 2px solid #8f60ff;
     
        color: white;
      }
    }
  }

  .customer-assist-box {
    background: #161838;
    padding: 20px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    border-radius: 10px;
    overflow-y: scroll;
      /* max-height: calc(100vh - 253px);
       */
       max-height: 517px;
       min-height:517px;
  }
  .interaction-column {
      display: flex;
      flex-direction: column;
      /* justify-content: space-between; */
      width: 35%;

      @media (min-width: 992px) {
        width: 35%;
        margin-left: 20px;
      }

      .call-history {
        flex: 0 0 30%;
        background: #42466b;
        border-radius: 10px;
        margin-bottom: 20px;
        padding: 10px;
      }

      .transcription {
        flex: 1 1;
        background: #42466b;
        border-radius: 10px;
        padding: 10px;
      }

      .accordion {
          background: #202342;
          
  
          .accordion-header {
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            color: white;
            font-weight: bold;
            padding: 10px;
          }
  
          .accordion-body {
            /* padding: 10px; */
            padding: 0 !important;
            background: #42466B;

            /* border-radius: 0 0 10px 10px; */
            color: white;
          }
  
          .arrow {
            font-size: 12px;
          }
        }
  
        .call-history {
          flex: 0 0 30%;
        }
  
    }

}

@media (min-width: 768px) {
  .customer-dashboard {
    .customer-head-box .customer-header {
      flex-direction: column;
      align-items: flex-start;
    }

    .customer-tabs {
      justify-content: flex-start;
    }
  }
}

@media (min-width: 992px) {
  .customer-dashboard {
    .customer-assist-box {
      display: flex;
      flex-direction: column;
    }
  }
}

.cust-conf-box{
  border: 1px solid #A4A4A4;
  margin-left: 15px;
  color:white;
  border-radius:10px;
}

.cust-conf-footer{
  margin-bottom: 20px;
}

.cust-conf-button{
  border-radius: 10px;
  background: transparent;
  color:white;
  margin-left:15px;
  width:25%;
  font-size: 12px;
  border:1px solid #6B5CD1;

  &.active{
    background: #6B5CD1;
 
  }
}

.cust-conf-header{
  background: #42466B;
  color:white;
  padding-top: 3px;
  padding-bottom: 6px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.cnf-text{
  font-size: 12px;
}

.cust-conf-body{   
  box-shadow: 0px 2px 4px 0px #00000014;
  
  padding:17px;
}

.cust-conf-subBody{
  padding:8px;
  border: 1px solid #FDC571;
  background: #363955;
  border-radius:3px;
  padding-top:12px;
  padding-bottom: 12px;
}

.cust-reason{
background: #00F2C2;
color: black;
border-radius: 11px;
padding: 3px;
font-size: 12px;
margin-left: 15px;
padding-left: 8px;
padding-right: 8px;
}

.customer-table-box{
  background: #363955;
  font-size: 12px;
  padding:20px;
  /* background-color: red; */
  margin-top:20px;
  border-radius: 10px;
}

.customer-table{
 border-radius:10px;
 background-color: white;
 width:100%;
 margin-top:10px;
}

.customer-table thead{
  background: #F5F5F5;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.customer-table td{
padding:15px;
}

.customer-table th{
  padding:15px;
 }

.cust-tabl-head{
  color:white;
}
.cust-warningIcon{
  height:20px;
  width:20px;
}
.right-tab-header {
background: #42466B;
border-radius: 30px;
padding: 2px;
}
.call-history-tab-button {
min-width: 100px;
border-radius: 30px;
background: #42466B;
border: none !important;
}

.call-tabs button.active {
background: #00ADEB;
border-bottom: none;
}

.cust-pieChartContainer{
  border-radius: 10px;
}

.cust-pie-wrapper{
  background-color: white;
  border-radius: 10px;
  padding-top: 20px;
    padding-right: 15px;
}

.assist-text-style{
  color:white;
  font-size: 12px;
}

.assist-msg-style{
   padding: 5px;
  box-shadow: 0px 2px 4px 0px #00000014;
  background: #363955;
  margin-top:15px;
  border-radius: 10px;
  padding-left:12px;
  padding-right:12px;
}`, "",{"version":3,"sources":["webpack://./src/CustomerCare/CustomerCareHome.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;;EAEpB;IACE,mBAAmB;IACnB,4BAA4B;IAC5B,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;;IAElB;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;;MAEvB;QACE,YAAY;QACZ,eAAe;QACf,gBAAgB;MAClB;;MAEA;QACE,eAAe;QACf,cAAc;MAChB;IACF;EACF;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;;IAElB;MACE,aAAa;MACb,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,YAAY;MACZ,oCAAoC;MACpC,eAAe;MACf,cAAc;MACd,UAAU;MACV,iBAAiB;;MAEjB;QACE,gCAAgC;;QAEhC,YAAY;MACd;IACF;EACF;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,gCAAgC;IAChC,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;MAChB;QACE;OACD,iBAAiB;OACjB,gBAAgB;EACrB;EACA;MACI,aAAa;MACb,sBAAsB;MACtB,oCAAoC;MACpC,UAAU;;MAEV;QACE,UAAU;QACV,iBAAiB;MACnB;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,mBAAmB;QACnB,aAAa;MACf;;MAEA;QACE,SAAO;QACP,mBAAmB;QACnB,mBAAmB;QACnB,aAAa;MACf;;MAEA;UACI,mBAAmB;;;UAGnB;YACE,aAAa;YACb,8BAA8B;YAC9B,eAAe;YACf,YAAY;YACZ,iBAAiB;YACjB,aAAa;UACf;;UAEA;YACE,mBAAmB;YACnB,qBAAqB;YACrB,mBAAmB;;YAEnB,kCAAkC;YAClC,YAAY;UACd;;UAEA;YACE,eAAe;UACjB;QACF;;QAEA;UACE,aAAa;QACf;;IAEJ;;AAEJ;;AAEA;EACE;IACE;MACE,sBAAsB;MACtB,uBAAuB;IACzB;;IAEA;MACE,2BAA2B;IAC7B;EACF;AACF;;AAEA;EACE;IACE;MACE,aAAa;MACb,sBAAsB;IACxB;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,wBAAwB;;EAExB;IACE,mBAAmB;;EAErB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;;EAErC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;AACA,mBAAmB;AACnB,YAAY;AACZ,mBAAmB;AACnB,YAAY;AACZ,eAAe;AACf,iBAAiB;AACjB,iBAAiB;AACjB,kBAAkB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,UAAU;CACV,eAAe;AAChB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;AACA,YAAY;AACZ;;AAEA;EACE,YAAY;CACb;;AAED;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;AACA,mBAAmB;AACnB,mBAAmB;AACnB,YAAY;AACZ;AACA;AACA,gBAAgB;AAChB,mBAAmB;AACnB,mBAAmB;AACnB,uBAAuB;AACvB;;AAEA;AACA,mBAAmB;AACnB,mBAAmB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;IACf,mBAAmB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;GACG,YAAY;EACb,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".customer-dashboard {\n  background: #363955;\n  border-radius: 15px;\n  margin: 0 auto;\n  /* padding: 20px; */\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-left: 20px;\n  margin-bottom: 45px;\n  padding-bottom: 20px;\n\n  .customer-head-box {\n    background: #42466b;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    width: 100%;\n    padding: 10px 20px;\n\n    .customer-header {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n\n      .customer-heading {\n        color: white;\n        font-size: 16px;\n        font-weight: 700;\n      }\n\n      .customer-dtTime {\n        font-size: 12px;\n        color: #acacac;\n      }\n    }\n  }\n\n  .customer-tabs {\n    display: flex;\n    /* justify-content: center; */\n    width: 100%;\n    margin: 10px 0 0 0;\n\n    .customer-tab-button {\n      /* flex: 1; */\n      padding: 2px;\n      cursor: pointer;\n      background: none;\n      border: none;\n      border-bottom: 2px solid transparent;\n      font-size: 12px;\n      color: #99adc4;\n      width: 13%;\n      margin-left: 40px;    \n\n      &.active {\n        border-bottom: 2px solid #8f60ff;\n     \n        color: white;\n      }\n    }\n  }\n\n  .customer-assist-box {\n    background: #161838;\n    padding: 20px;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    margin-left: 20px;\n    border-radius: 10px;\n    overflow-y: scroll;\n      /* max-height: calc(100vh - 253px);\n       */\n       max-height: 517px;\n       min-height:517px;\n  }\n  .interaction-column {\n      display: flex;\n      flex-direction: column;\n      /* justify-content: space-between; */\n      width: 35%;\n\n      @media (min-width: 992px) {\n        width: 35%;\n        margin-left: 20px;\n      }\n\n      .call-history {\n        flex: 0 0 30%;\n        background: #42466b;\n        border-radius: 10px;\n        margin-bottom: 20px;\n        padding: 10px;\n      }\n\n      .transcription {\n        flex: 1;\n        background: #42466b;\n        border-radius: 10px;\n        padding: 10px;\n      }\n\n      .accordion {\n          background: #202342;\n          \n  \n          .accordion-header {\n            display: flex;\n            justify-content: space-between;\n            cursor: pointer;\n            color: white;\n            font-weight: bold;\n            padding: 10px;\n          }\n  \n          .accordion-body {\n            /* padding: 10px; */\n            padding: 0 !important;\n            background: #42466B;\n\n            /* border-radius: 0 0 10px 10px; */\n            color: white;\n          }\n  \n          .arrow {\n            font-size: 12px;\n          }\n        }\n  \n        .call-history {\n          flex: 0 0 30%;\n        }\n  \n    }\n\n}\n\n@media (min-width: 768px) {\n  .customer-dashboard {\n    .customer-head-box .customer-header {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    .customer-tabs {\n      justify-content: flex-start;\n    }\n  }\n}\n\n@media (min-width: 992px) {\n  .customer-dashboard {\n    .customer-assist-box {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n}\n\n.cust-conf-box{\n  border: 1px solid #A4A4A4;\n  margin-left: 15px;\n  color:white;\n  border-radius:10px;\n}\n\n.cust-conf-footer{\n  margin-bottom: 20px;\n}\n\n.cust-conf-button{\n  border-radius: 10px;\n  background: transparent;\n  color:white;\n  margin-left:15px;\n  width:25%;\n  font-size: 12px;\n  border:1px solid #6B5CD1;\n\n  &.active{\n    background: #6B5CD1;\n \n  }\n}\n\n.cust-conf-header{\n  background: #42466B;\n  color:white;\n  padding-top: 3px;\n  padding-bottom: 6px;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.cnf-text{\n  font-size: 12px;\n}\n\n.cust-conf-body{   \n  box-shadow: 0px 2px 4px 0px #00000014;\n  \n  padding:17px;\n}\n\n.cust-conf-subBody{\n  padding:8px;\n  border: 1px solid #FDC571;\n  background: #363955;\n  border-radius:3px;\n  padding-top:12px;\n  padding-bottom: 12px;\n}\n\n.cust-reason{\nbackground: #00F2C2;\ncolor: black;\nborder-radius: 11px;\npadding: 3px;\nfont-size: 12px;\nmargin-left: 15px;\npadding-left: 8px;\npadding-right: 8px;\n}\n\n.customer-table-box{\n  background: #363955;\n  font-size: 12px;\n  padding:20px;\n  /* background-color: red; */\n  margin-top:20px;\n  border-radius: 10px;\n}\n\n.customer-table{\n border-radius:10px;\n background-color: white;\n width:100%;\n margin-top:10px;\n}\n\n.customer-table thead{\n  background: #F5F5F5;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.customer-table td{\npadding:15px;\n}\n\n.customer-table th{\n  padding:15px;\n }\n\n.cust-tabl-head{\n  color:white;\n}\n.cust-warningIcon{\n  height:20px;\n  width:20px;\n}\n.right-tab-header {\nbackground: #42466B;\nborder-radius: 30px;\npadding: 2px;\n}\n.call-history-tab-button {\nmin-width: 100px;\nborder-radius: 30px;\nbackground: #42466B;\nborder: none !important;\n}\n\n.call-tabs button.active {\nbackground: #00ADEB;\nborder-bottom: none;\n}\n\n.cust-pieChartContainer{\n  border-radius: 10px;\n}\n\n.cust-pie-wrapper{\n  background-color: white;\n  border-radius: 10px;\n  padding-top: 20px;\n    padding-right: 15px;\n}\n\n.assist-text-style{\n  color:white;\n  font-size: 12px;\n}\n\n.assist-msg-style{\n   padding: 5px;\n  box-shadow: 0px 2px 4px 0px #00000014;\n  background: #363955;\n  margin-top:15px;\n  border-radius: 10px;\n  padding-left:12px;\n  padding-right:12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
